import { render, staticRenderFns } from "./OnRHFss.vue?vue&type=template&id=246e3cd0&"
import script from "./OnRHFss.vue?vue&type=script&lang=js&"
export * from "./OnRHFss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports